import { render, staticRenderFns } from "./DialogBaseCloseIcon.vue?vue&type=template&id=319c1977&scoped=true&"
import script from "./DialogBaseCloseIcon.vue?vue&type=script&lang=js&"
export * from "./DialogBaseCloseIcon.vue?vue&type=script&lang=js&"
import style0 from "./DialogBaseCloseIcon.vue?vue&type=style&index=0&id=319c1977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319c1977",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
